import React, { memo } from 'react';
import { Gift, Clock, Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BonusSection() {
  const scrollToPurchase = () => {
    const element = document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const bonuses = [{
    title: 'Bono #1: Matemáticas Inicial',
    subtitle: 'Aprender Jugando',
    description: 'Números, conteo, sumas y restas simples. ¡Las matemáticas nunca fueron tan divertidas!',
    image: 'https://cdn.magicpatterns.com/uploads/oD22zJA4GafdHttCdych2p/portada_bono_1_matematicas_inicial.jpg',
    value: '$10,000',
    color: 'blue',
    bg: 'bg-blue-50',
    border: 'border-blue-200'
  }, {
    title: 'Bono #2: Emociones',
    subtitle: 'Gestión Emocional',
    description: 'Herramientas para identificar emociones, manejo del enojo y actividades para reducir berrinches.',
    image: 'https://cdn.magicpatterns.com/uploads/bQRe46ZJyub8dMBCwm6sfr/portada_bono_2_emociones_y_conductas.jpg',
    value: '$10,000',
    color: 'purple',
    bg: 'bg-purple-50',
    border: 'border-purple-200'
  }, {
    title: 'Bono #3: Estimulación',
    subtitle: 'Desarrollo Integral',
    description: 'Ejercicios para potenciar la atención, memoria y motricidad fina desde temprana edad.',
    image: 'https://cdn.magicpatterns.com/uploads/gR22qmmqiTBToNNPdt8jeS/portada_bono_3_estimulacion_temprana.png',
    value: '$10,000',
    color: 'green',
    bg: 'bg-green-50',
    border: 'border-green-200'
  }];
  return <section className="bg-doodles-blue py-20 px-4 relative" data-id="element-18">
      <div className="max-w-6xl mx-auto" data-id="element-19">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-20">
          <div className="inline-flex items-center gap-2 bg-red-100 text-red-600 px-6 py-2 rounded-full font-black text-sm md:text-base mb-4 animate-pulse border-2 border-red-200 shadow-sm" data-id="element-21">
            <Clock className="w-5 h-5" data-id="element-22" />
            PROMOCIÓN VÁLIDA SOLO POR HOY
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-23">
            🎁 REGALOS{' '}
            <span className="text-green-600 bg-green-100 px-2 rounded-lg transform -rotate-2 inline-block" data-id="element-24">
              GRATIS
            </span>
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-25">
            Si ordenas hoy, te llevas estos 3 increíbles bonos sin costo
            adicional.
          </p>
        </div>

        {/* Bonuses Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-26">
          {bonuses.map((bonus, index) => <div key={index} className={`flex flex-col h-full border-4 ${bonus.border} rounded-[2rem] p-6 hover:scale-105 transition-transform duration-300 ${bonus.bg} shadow-lg relative`} data-id="element-27">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-yellow-400 text-red-900 font-black text-xs py-1 px-4 rounded-full shadow-md whitespace-nowrap border-2 border-white" data-id="element-28">
                VALOR:{' '}
                <span className="line-through opacity-70" data-id="element-29">{bonus.value}</span> •
                ¡GRATIS!
              </div>

              <div className="cursor-pointer overflow-hidden rounded-2xl mb-6 aspect-square relative group border-4 border-white shadow-sm mt-4" onClick={scrollToPurchase} data-id="element-30">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-31" />
              </div>

              <h3 className={`text-xl font-black text-center mb-2 text-${bonus.color}-600`} data-id="element-32">
                {bonus.title}
              </h3>
              <p className="text-center font-bold text-gray-500 mb-3 text-xs uppercase tracking-wide bg-white/50 py-1 rounded-lg" data-id="element-33">
                {bonus.subtitle}
              </p>
              <p className="text-center text-gray-600 text-sm flex-grow font-medium" data-id="element-34">
                {bonus.description}
              </p>
            </div>)}
        </div>

        <CTAButton text="¡QUIERO MIS BONOS GRATIS!" data-id="element-35" />
      </div>
    </section>;
}